export default {
  authenticated: state => state.authenticated,
  email: state => state.profile.email,
  login: state => state.profile.login,
  fullname: state => state.profile.full_name,
  name: state => state.profile.name,
  role: state => state.profile.role,
  isAdmin: state => state.profile.role === 'admin',
};
